import React from 'react';

const ErrorFallback = ({ error }) => (
  <div role="alert" className='error-fallback-container'>
    <div className='error-fallback'>
      <div className='error-fallback-title'>
        <span className="k-icon k-i-error" />
        <span>Something went wrong</span>
      </div>
      <div className='error-fallback-details'>{error?.message}</div>
      <div className='error-fallback-stack'>
        {error?.stack.split('\n').map((line) => <div key={line}>{line}</div>)}
      </div>
    </div>
  </div>
);

export default ErrorFallback;
